import React from 'react'
import PropTypes from 'prop-types'

/* doc
---
title: Select
name: Select
category: React - Bulma
---
A `Select` component based on Bulma `.select`. This is a wrapper for select fields.

If you're trying to build a form, take a look at the `SelectField` component.

See [Bulma Documentation](http://bulma.io/documentation/form/select/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.

### Props
| Prop Name       | Description                                   |Type            | Default Value             | Required?     |
|-----------------|-----------------------------------------------|----------------|---------------------------|---------------|
| inputSize       | Input size.                                   | string         |                           | no            |

```html_example
  <form>
    <Field>
      <Label htmlFor="example">Input name</Label>
      <Control>
        <Select name="example" type="text" onChange={onChangeHandler}>
          ...
        </Select>
      </Control>
    </Field>
  </form>
```
*/

/**
* @TODO Automatically set accessibility attributes.
* @TODO Add support for input states.
* @TODO Add support for icons.
*/
function Select(props) {
  const {
    name, children, className, inputSize, multiple, onChange, ...rest
  } = props

  const classes = [
    'select',
    inputSize ? `is-${inputSize}` : '',
    multiple ? 'is-multiple' : '',
    className || '',
  ]

  const onChangeHandler = (e) => {
    if (typeof onChange === 'function') {
      onChange(name, e.target.value)
    }
  }

  return (
    <div className={classes.join(' ')}>
      <select
        id={name}
        multiple={multiple}
        {...rest}
        name={name}
        onChange={onChangeHandler}
      >
        {children}
      </select>
    </div>
  )
}

Select.defaultProps = {
  multiple: false,
}

Select.propTypes = {
  // Name/id of input.
  name: PropTypes.string.isRequired,
  // Size of input: "small", "medium", "large"
  inputSize: PropTypes.string,
  // Allow multiple items to be selected.
  multiple: PropTypes.bool,
}

export default Select
